var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("destination-business-tree-grid", {
        ref: "treeGrid",
        attrs: { "menu-type": _vm.menuType, "can-edit": _vm.canEdit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }